export default __webpack_public_path__ + "static/tmb-3-7bf9806124ccf53b11670d72166ff4ce.png";